import { createStyles } from '@material-ui/core';
const styles = (): any =>
    createStyles({
        header: {},
    });
export default styles;
